import React from 'react';

interface TitleInputProps {
  title: string;
  setTitle: (value: string) => void;
}

const TitleInput: React.FC<TitleInputProps> = ({ title, setTitle }) => {
  return (
    <div className="flex items-center">
      <label
        htmlFor="title"
        className="block text-base font-semibold text-gray-700 min-w-[45px]"
      >
        제목
      </label>
      <input
        type="text"
        id="title"
        placeholder="제목을 입력하세요."
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="block min-w-[450px] w-full px-3 py-2 ml-2 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
      />
    </div>
  );
};

export default TitleInput;
